import "./Appmenu.scss";

import * as React from "react";
import { useState } from "react";
import PropTypes from "prop-types";
import Slide from "../../animation/Slide";
import { buildUrl } from "../../utils/helper";
import withMeta from "../../utils/withMeta";
import withRequests from "../../utils/withRequests";
import { useDidMount } from "../../utils/hooks";
import { SafeSVG } from "../../svg/SafeSVG";

/**
 * App menu component
 * @module
 * @param {string} sidebarType -Sidebar type ('normal','compact','fullscreen') 
 * @param {bool} isOpen - Is slide open
 * @param {func} onClose - Function invoked on close 
 */

const Appmenu = (props) => {
  const [state, setState] = useState({
    appmenu: null,
  });

  const defaultApps = () => {
    return (
      <React.Fragment>
        <div
          className="nav_app_button"
          onClick={() => {
            window.open(
              "http://cghelpdesk.corageo.sk/",
              "_blank",
              "noopener,noreferrer"
            );
          }}
        >
          <div className="icone" value="CG1">
            HD
          </div>
          <div className="popis">HelpDesk</div>
        </div>
      </React.Fragment>
    );
  };

  const handleChange = (event) => {
    alert("Vybrane bolo: " + state.value);
    event.preventDefault();
  };

  const handleClick = async (app) => {
    let url = app.NUrl;
    if (app.LPrj) {
      const res = await props.requests.getRedirectToken();
      if (res?.Token) {
        url = `${url}#/prihlasenie?rt=${res.Token}`;
      }
    }
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handleBuildApps = (apps) => {
    if (apps && apps.length > 0) {
      return (
        <React.Fragment>
          {apps.map((app) => (
            <div
              className="nav_app_button"
              key={app.IApl}
              onClick={() => { handleClick(app); }}
            >
              {app.IkoCesta && (
                <div className="icon" value={app.SkrApl}>
                  <SafeSVG src={buildUrl(app.IkoCesta)} alt={app.SkrApl} />
                </div>
              )}
              {!app.IkoCesta && (
                <div className="icone" value={app.SkrApl}>
                  {app.SkrApl}
                </div>
              )}
              <div className="popis">{app.NApl}</div>
            </div>
          ))}
        </React.Fragment>
      );
    } else {
      return defaultApps();
    }
  };

  useDidMount(async () => {
    const res = await props.meta.getApl();
    setState(prevState => ({ ...prevState, appmenu: handleBuildApps(res) }));
  });

  return (
    <nav className="appmenu">
      <Slide isOpen={props.isOpen} onClose={props.handleCloseAppmenu}>
        <div className="wrapper-scroll"
        >
          <div
            className={`info-okno-left ${props.sidebarType === "fullscreen" ? "fullscreen" : ""}`}
            value={state.value}
            onChange={handleChange}
          >
            {state.appmenu}
          </div>
        </div>
      </Slide>
    </nav>
  );
};

Appmenu.propTypes = {
  sidebarType: PropTypes.oneOf([
    'normal',
    'compact',
    'fullscreen',
  ]),
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default withMeta(withRequests(Appmenu));
